<template>
    <div class="configuraciones-container">
        <h2>Configuraciones</h2>
        <el-row :gutter="20">
            <el-col :span="24">
                <el-card>
                    <div slot="header">
                        <span>Configuraciones del Sistema</span>
                    </div>
                    <div>
                        Contenido de Configuraciones
                    </div>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
    name: 'BotConfiguraciones',
    data() {
        return {
            token: this.$route.query.token
        }
    }
}
</script>

<style lang="scss" scoped>
.configuraciones-container {
    padding: 20px;
}
</style> 